import { Box } from "@mui/material";

type Size = "xs" | "sm" | "md";

type Props = {
  color?: string;
  size?: Size;
};

const dotSize: Record<Size, string> = {
  xs: "2px",
  sm: "4px",
  md: "6px",
};

export const Dot = ({ color = "grey.300", size = "sm" }: Props) => {
  return <Box width={dotSize[size]} height={dotSize[size]} bgcolor={color} borderRadius="50%" flexShrink={0} />;
};
